export enum DocumentViewMode {
  teacher = "teacher",
  student = "student",
  compare = "compare",
}
